import { Paper, Typography } from "@mui/material";
import React from "react";
import { SensorType, TypeSensor } from "../../pages/camaras/interface/camara.interface";
import moment from "moment";
import { usePageVisibility } from "../../pages/camaras/usePageVisibility";
import Tooltip from '@mui/material/Tooltip';

type CardProps = {
    propsSensor: TypeSensor;
}

export const MensajeComponent: React.FC<CardProps> = ({propsSensor}) => {

    const isPageVisible = usePageVisibility();
    const timerIdRef = React.useRef<NodeJS.Timer | null>(null); 

    const [estado, setEstado] = React.useState<boolean>(true);

    React.useEffect(() => {
        if (moment().diff(propsSensor.valores[0].fecha_hora_value, 'minute') > 5) //Controla que se actualizen los valores
            setEstado(false);
        else
            setEstado(true);


        const controllingCallback = () => {
            if (moment().diff(propsSensor.valores[0].fecha_hora_value, 'minute') > 5) //Controla que se actualizen los valores
                setEstado(false);
            else
                setEstado(true);
        };

        const startPolling = () => {
            timerIdRef.current = setInterval(controllingCallback, 60000); //Cada 1 minuto
        };

        const stopPolling = () => {
            clearInterval(timerIdRef.current!);
        };

        if (isPageVisible) {
            startPolling();
        } else {
            stopPolling();
        }

        return () => {
            stopPolling();
        };

    }, [propsSensor,  isPageVisible]);

    const getValor = (sensor:TypeSensor) => {
        switch (sensor.tipo_sensor) {
            case SensorType.MENSAJE_FUNCIONAMIENTO:
                return sensor.valores[0].value;
            default:
                return null;
        }    
    }
    
    return (
        <Paper
            elevation={3} // profundidad
            sx={{
                minwidth: 50,
                minheight: 50,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",
                p: 1,
                backgroundColor: "#f5f5f5",
            }}
        >
            {(propsSensor.valores?.length !== 0 && estado) ?(
                <>
                {/* Título */}
                <Typography                         
                    variant = "caption" 
                    align="center"
                    >
                    {propsSensor.name_front}
                </Typography>

                <Paper
                    elevation={3}
                    sx={{
                    backgroundColor: propsSensor.color_fondo,
                    color: propsSensor.color_fuente,
                    px: 2,
                    py: 1,
                    borderRadius: 2,
                    flex: 1, // se adapta al ancho disponible
                    }}
                >
                    <Tooltip 
                            title={`Ultima muestra: ${moment(propsSensor.valores[0].fecha_hora_value).format("DD/MM/YYYY HH:mm")}
                            Descirpcion: ${propsSensor.descripcion} `} 
                    >
                        <Typography
                        variant="body2"
                        sx={{
                            whiteSpace: "normal", // permite que se divida en varias líneas
                            wordWrap: "break-word",
                            textAlign: "left",
                            minWidth: "100px"
                        }}
                        >
                            {getValor(propsSensor)}
                        </Typography>
                    </Tooltip>
                </Paper>
                </>) : (" ")
            }

        </Paper>


    )
}


/*
        <Box display="flex" alignItems="center" mb={2}>
        {(propsSensor.valores?.length !== 0 && estado) ?(
            <>
                {/* Etiqueta a la izquierda }
                <Box
                    maxWidth={"130px"}
                    sx={{ 
                        mr: 1,
                        wordWrap: "break-word", 
                    }}
                >
                    <Typography
                        variant="body2"

                    >
                        {propsSensor.name_front}:
                    </Typography>
                </Box>
                <Paper
                    elevation={3}
                    sx={{
                    backgroundColor: propsSensor.color_fondo,
                    color: propsSensor.color_fuente,
                    px: 2,
                    py: 1,
                    borderRadius: 2,
                    flex: 1, // se adapta al ancho disponible
                    }}
                >
                    <Tooltip 
                            title={`Ultima muestra: ${moment(propsSensor.valores[0].fecha_hora_value).format("DD/MM/YYYY HH:mm")}
                            Descirpcion: ${propsSensor.descripcion} `} 
                    >
                        <Typography
                        variant="body2"
                        sx={{
                            whiteSpace: "normal", // permite que se divida en varias líneas
                            wordWrap: "break-word",
                            textAlign: "left",
                            minWidth: "100px"
                        }}
                        >
                            {getValor(propsSensor)}
                        </Typography>
                    </Tooltip>
                </Paper>
            </>) : (" ")
        }
        </Box>

*/
